import * as api from './middleware/api.middleware';
import { IResponseCollection } from '../interfaces/general.interfaces';
import {
    IGetOrganisationsRequest,
    IOrganisationDetails,
    IOrganisationIdent,
} from '../interfaces/organisations.interfaces';
import {
    IContactPoint,
    IOrganisationContactGroupsWithContactPointsResponse,
} from '../interfaces/contactpoint.interfaces';
import { ISenderRequest } from '../interfaces';

const serviceUrl = '/organisationservice/v2';

export function getOrgainsationDetails(organisationId: string) {
    return api.get<IOrganisationDetails>(`${serviceUrl}/organisations/${organisationId}`);
}

export function getContactPoint(organisationId: string, contactPointId: string) {
    return api.get<IContactPoint>(`${serviceUrl}/organisation/${organisationId}/contact-point/${contactPointId}`);
}

export function getOrganisationsBySearchValue(request: IGetOrganisationsRequest | ISenderRequest) {
    return api.post<IResponseCollection<IOrganisationIdent>>(`${serviceUrl}/organisations`, request);
}

export function getContactGroupsAndContactPointsByOrganisationId(
    organisationId: string,
    targets: string,
    organisationName: string
) {
    return api.get<IOrganisationContactGroupsWithContactPointsResponse>(
        `${serviceUrl}/organisation/${organisationId}/contact-groups_contact-points?targets=${targets}&parentName=${organisationName}`
    );
}

export function getContactGroupsAndContactPointsByOrganisationGroupId(
    organisationId: string,
    contactGroupId: string,
    fullName: string,
    targets: string
) {
    return api.get<IOrganisationContactGroupsWithContactPointsResponse>(
        `${serviceUrl}/organisation/${organisationId}/contact-group/${contactGroupId}/contact-groups_contact-points?targets=${targets}&parentName=${fullName}`
    );
}
